import { useLocation } from '@solidjs/router';
import { onMount, Show } from 'solid-js';
import { palette } from 'Shared/frontend/SettingsProvider';


export function Reveal(P)
{
	return (
		<Show when={P.when}>
			<Contents>
				{P.children}
			</Contents>
		</Show>
	);
}

function Contents(P)
{
	const background = palette().background;

	onMount(() => {
		scrollPage();

		setTimeout(() => {
			/* Also see OuterPage.tsx */
			document.body.style.backgroundColor = background;
			document.body.style.opacity = '1';
		},100);
	});

	return (<>
		{P.children}
	</>);
}

/* Also see OuterBasic.tsx */
function scrollPage()
{
	//NOTE maybe useful in future : https://github.com/solidjs/solid-router/issues/99

	const firstPage = window['scrollPositions'] == undefined;

	if (firstPage) {
		window['scrollPositions'] = {};

		/* Jump to hash */
		const hash = location.hash;
		if (hash?.length > 0) {
			location.hash = '';
			setTimeout(() => location.hash = hash,1);
		}
		return;
	}

	const path = useLocation().pathname.split('#')[0];
	const pos = window.scrollPositions[path] ?? 0;

	/* Jump to previous place on page: */
	if (pos!=undefined)
		setTimeout(() => window.scrollTo({top: pos}),1);
}


